module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/.6.26.0@babel-runtime/core-js/array/from.js
// module id = 568
// module chunks = 1